// Keep in sync with CSS (/source/sass/main/_variables.scss)
export const BREAKPOINT_DESKTOP = '(min-width: 768px)'; // Desktop & up
export const BREAKPOINT_TABLET = '(max-width: 767.98px)'; // Tablet & down
export const BREAKPOINT_MOBILE = '(max-width: 480px)'; // Mobile & down
export const BACKGROUND_GRADIENT = 'linear-gradient(45deg, #8700f5, #00c7ff)'; // Keep in sync with $radancy-gradient

// Languages platform is translated to
const UI_LANGUAGES = {
  bg_BG: 'languages.bulgarian',
  cs_CZ: 'languages.czech',
  de_DE: 'languages.german',
  en_US: 'languages.english',
  es_ES: 'languages.spanish',
  fi_FI: 'languages.finnish',
  fr_FR: 'languages.french',
  ko_KR: 'languages.korean',
  hr_HR: 'languages.croatian',
  hu_HU: 'languages.hungarian',
  it_IT: 'languages.italian',
  nl_NL: 'languages.dutch',
  pl_PL: 'languages.polish',
  pt_PT: 'languages.portuguese',
  ro_RO: 'languages.romanian',
  sk_SK: 'languages.slovak',
  tr_TR: 'languages.turkish',
  th_TH: 'languages.thai',
  zh_CN: 'languages.chinese-simplified',
  ja_JP: 'languages.japanese'
};

// Special languages which are used as an override for another language
const OVERRIDING_LANGUAGES = {
  ak_GH: 'languages.german-formal'
};

// All possible values of platform language
export const LANGUAGES = {
  ...UI_LANGUAGES,
  ...OVERRIDING_LANGUAGES
};

//Whenever you add a new language feature toggle, add it here so that it doesn't get used on $translate
//example of how it should look - 'Languages.Korean': 'ko_KR'
export const FEATURE_FLAGGED_LANGUAGES = {
  'Languages.Korean': 'ko_KR',
  'Languages.Thai': 'th_TH',
  'Languages.Finnish': 'fi_FI',
  'Languages.Turkish': 'tr_TR',
  'Languages.Japanese': 'ja_JP'
};

// All possible values of locale-piker component languages
export const LEGAL_TERMS_LANGUAGES = {
  ...UI_LANGUAGES,
  da_DK: 'languages.danish',
  el_GR: 'languages.greek',
  id_ID: 'languages.indonesian',
  ja_JP: 'languages.japanese',
  ms_MY: 'languages.malay',
  no_NO: 'languages.norwegian',
  ru_RU: 'languages.russian',
  sv_SE: 'languages.swedish',
  vi_VN: 'languages.vietnamese',
  zh_TW: 'languages.chinese-traditional'
};

// List of GET parameters to filter from URL on the app load.
// They are expected to come from email tracking and intended for Matomo analytics only.
export const MATOMO_CAMPAIGN_URL_PARAMS = [
  'action_name',
  'bots',
  'idsite',
  'mtm_campaign',
  'mtm_cid',
  'mtm_content',
  'mtm_group',
  'mtm_kwd',
  'mtm_medium',
  'mtm_placement',
  'mtm_source',
  'rec',
  'url'
];

export const EVENTS = {
  AUTH_SERVICE: {
    END_SESSION: 'auth-service.end-session'
  },
  LOGIN: {
    AUTHORIZATION_CODE_RECEIVED: 'login.authorization-code-received',
    ACCESS_TOKEN_RECEIVED: 'login.access-token-received'
  },
  PAGE_TRACKED: 'page-tracked',
  REVOKE_REWARD: 'revoke-reward',
  CREATE_REFERRAL_MANUALLY: 'create-referral-manually',
  INVITE_USER: {
    SAVE_FORM: 'invite-user.save-form'
  }
};

export default {
  ACTIVITY_ACTOR: {
    COMPANY: 'COMPANY',
    USER: 'USER'
  },
  APPLICATION_STATUS: {
    CLOSED: 'CLOSED',
    DELETED: 'DELETED',
    HIRED: 'HIRED',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING'
  },
  COMPANY_FIELDS: [
    'city',
    'companySize',
    'country',
    'currency',
    'cvRequired',
    'id',
    'name',
    'postalCode',
    'street',
    'website',
    'rewardPaymentBehaviorCode',
    'logo'
  ],
  DASHBOARD_BASE: '/dashboard',
  DEFAULT_BRANDING_UUID: '00000000-0000-0000-0000-000000000000',
  DEFAULT_PROFILE_PICTURE_PATH: '/assets/images/base/profile-picture.svg',
  DEFAULT_SHARING_TEXTS: {
    // @NB: should be maintained with new languages, share options
    email: {
      ak_GH:
        'Guten Tag, diese Stelle könnte für Sie passen! Ich würde Sie mit meiner persönlichen Empfehlung unterstützen.',
      bg_BG:
        'Здравейте! Според мен сте чудесен кандидат за отворена позиция за работа в моята компания и бих се радвал(а) да Ви изпратя личната си препоръка.',
      cs_CZ:
        'Ahoj! Myslím, že jsi skvělý kandidát / skvělá kandidátka na otevřenou pozici v mé společnosti a rád(a) bych ti poskytl(a) osobní doporučení.',
      de_DE: 'Hallo, wäre das nichts für dich? Ich würde dich mit meiner persönlichen Empfehlung unterstützen.',
      en_US:
        "Hey there! I think you're a great candidate for an open position at my company and I would be happy to provide you with my personal referral.",
      es_ES:
        '¡Hola! Creo que eres un candidato fantástico para una oferta de empleo en mi empresa y me gustaría darte mi recomendación personal.',
      fi_FI:
        'Hei siellä! Mielestäni olet loistava ehdokas avoimeen tehtävään yrityksessäni, ja annan sinulle mielelläni henkilökohtaisen suositukseni.',
      fr_FR:
        'Bonjour! Je pense que tu es un candidat idéal pour un emploi vacant à mon entreprise et je serais heureux de te donner ma recommandation personnelle.',
      ko_KR:
        '이봐 거기! 나는 당신이 우리 회사의 공석에 대한 훌륭한 후보자라고 생각하며 내 개인적인 추천을 제공하게 되어 기쁩니다.',
      hr_HR:
        'Pozdrav! Mislim da si ti izvrstan kandidat za slobodno radno mjesto u našem poduzeću i bilo bi mi drago dati ti svoju osobnu preporuku.',
      hu_HU: 'Hello! Szerintem ideális jelölt lennél a cégem egy nyitott pozíciójára és örömmel be is ajánlanálak.',
      it_IT:
        'Ciao! Penso che tu sia un candidato perfetto per una posizione aperta presso la mia azienda e mi piacerebbe darti una segnalazione personale.',
      nl_NL:
        'Hallo! Ik denk dat jij een uitstekende kandidaat zou zijn voor een vacature bij mijn bedrijf. Ik wil je met plezier persoonlijk aanbevelen.',
      pl_PL:
        'Witaj! Myślę, że jesteś świetnym kandydatem na stanowisko w mojej firmie. Osobiście chciałbym Ci wystawić referencje.',
      pt_PT:
        'Olá! Considero-te um(a) candidato(a) fantástico(a) para uma posição aberta na minha empresa e gostaria de te oferecer a minha recomendação pessoal.',
      ro_RO:
        'Bună! Cred că ești un candidat foarte bun pentru o poziție disponibilă în cadrul companiei mele și mi-ar face plăcere să te recomand persona',
      sk_SK:
        'Zdravím! Myslím si, že ste skvelým uchádzačom na voľnú pracovnú ponuku v mojej spoločnosti a rád by som vám poskytol moje osobné odporúčanie.',
      tr_TR:
        'Selam! Şirketimdeki açık bir pozisyon için harika bir aday olduğunuzu düşünüyorum ve size kişisel tavsiyemi vermekten memnuniyet duyarım.',
      th_TH:
        'สวัสดี! ฉันคิดว่าคุณเป็นผู้สมัครที่ดีสำหรับตำแหน่งงานว่างที่บริษัทของฉัน และฉันยินดีที่จะให้คำแนะนำส่วนตัวแก่คุณ',
      zh_CN: '您好！我的公司正在公开招募的一个职位刚好适合您，我很乐意通过我的个人推荐来帮助您获得这个职位。',
      ja_JP: 'こんにちは！私はあなたが私の会社の空席に最適な候補者だと考えています。喜んで私自身の推薦を提供します。'
    },
    whatsapp: {
      ak_GH:
        'Guten Tag, diese Stelle könnte für Sie passen! Ich würde Sie mit meiner persönlichen Empfehlung unterstützen.',
      bg_BG:
        'Здравейте! Според мен сте чудесен кандидат за отворена позиция за работа в моята компания и бих се радвал(а) да Ви изпратя личната си препоръка.',
      cs_CZ:
        'Ahoj! Myslím, že jsi skvělý kandidát / skvělá kandidátka na otevřenou pozici v mé společnosti a rád(a) bych ti poskytl(a) osobní doporučení.',
      de_DE: 'Hallo, wäre das nichts für dich? Ich würde dich mit meiner persönlichen Empfehlung unterstützen.',
      en_US:
        "Hey there! I think you're a great candidate for an open position at my company and I would be happy to provide you with my personal referral.",
      es_ES:
        '¡Hola! Creo que eres un candidato fantástico para una oferta de empleo en mi empresa y me gustaría darte mi recomendación personal.',
      fi_FI:
        'Hei siellä! Mielestäni olet loistava ehdokas avoimeen tehtävään yrityksessäni, ja annan sinulle mielelläni henkilökohtaisen suositukseni.',
      fr_FR:
        'Bonjour! Je pense que tu es un candidat idéal pour un emploi vacant à mon entreprise et je serais heureux de te donner ma recommandation personnelle.',
      ko_KR:
        '이봐 거기! 나는 당신이 우리 회사의 공석에 대한 훌륭한 후보자라고 생각하며 내 개인적인 추천을 제공하게 되어 기쁩니다.',
      hr_HR:
        'Pozdrav! Mislim da si ti izvrstan kandidat za slobodno radno mjesto u našem poduzeću i bilo bi mi drago dati ti svoju osobnu preporuku.',
      hu_HU: 'Hello! Szerintem ideális jelölt lennél a cégem egy nyitott pozíciójára és örömmel be is ajánlanálak.',
      it_IT:
        'Ciao! Penso che tu sia un candidato perfetto per una posizione aperta presso la mia azienda e mi piacerebbe darti una segnalazione personale.',
      nl_NL:
        'Hallo! Ik denk dat jij een uitstekende kandidaat zou zijn voor een vacature bij mijn bedrijf. Ik wil je met plezier persoonlijk aanbevelen.',
      pl_PL:
        'Witaj! Myślę, że jesteś świetnym kandydatem na stanowisko w mojej firmie. Osobiście chciałbym Ci wystawić referencje.',
      pt_PT:
        'Olá! Considero-te um(a) candidato(a) fantástico(a) para uma posição aberta na minha empresa e gostaria de te oferecer a minha recomendação pessoal.',
      ro_RO:
        'Bună! Cred că ești un candidat foarte bun pentru o poziție disponibilă în cadrul companiei mele și mi-ar face plăcere să te recomand persona',
      sk_SK:
        'Zdravím! Myslím si, že ste skvelým uchádzačom na voľnú pracovnú ponuku v mojej spoločnosti a rád by som vám poskytol moje osobné odporúčanie.',
      tr_TR:
        'Selam! Şirketimdeki açık bir pozisyon için harika bir aday olduğunuzu düşünüyorum ve size kişisel tavsiyemi vermekten memnuniyet duyarım.',
      th_TH:
        'สวัสดี! ฉันคิดว่าคุณเป็นผู้สมัครที่ดีสำหรับตำแหน่งงานว่างที่บริษัทของฉัน และฉันยินดีที่จะให้คำแนะนำส่วนตัวแก่คุณ',
      zh_CN: '您好！我的公司正在公开招募的一个职位刚好适合您，我很乐意通过我的个人推荐来帮助您获得这个职位。',
      ja_JP: 'こんにちは！私はあなたが私の会社の空席に最適な候補者だと考えています。喜んで私自身の推薦を提供します。'
    },
    wechat: {
      ak_GH:
        'Guten Tag, diese Stelle könnte für Sie passen! Ich würde Sie mit meiner persönlichen Empfehlung unterstützen.',
      bg_BG:
        'Здравейте! Според мен сте чудесен кандидат за отворена позиция за работа в моята компания и бих се радвал(а) да Ви изпратя личната си препоръка.',
      cs_CZ:
        'Ahoj! Myslím, že jsi skvělý kandidát / skvělá kandidátka na otevřenou pozici v mé společnosti a rád(a) bych ti poskytl(a) osobní doporučení.',
      de_DE: 'Hallo, wäre das nichts für dich? Ich würde dich mit meiner persönlichen Empfehlung unterstützen.',
      en_US:
        "Hey there! I think you're a great candidate for an open position at my company and I would be happy to provide you with my personal referral.",
      es_ES:
        '¡Hola! Creo que eres un candidato fantástico para una oferta de empleo en mi empresa y me gustaría darte mi recomendación personal.',
      fi_FI:
        'Hei siellä! Mielestäni olet loistava ehdokas avoimeen tehtävään yrityksessäni, ja annan sinulle mielelläni henkilökohtaisen suositukseni.',
      fr_FR:
        'Bonjour! Je pense que tu es un candidat idéal pour un emploi vacant à mon entreprise et je serais heureux de te donner ma recommandation personnelle.',
      ko_KR:
        '이봐 거기! 나는 당신이 우리 회사의 공석에 대한 훌륭한 후보자라고 생각하며 내 개인적인 추천을 제공하게 되어 기쁩니다.',
      hr_HR:
        'Pozdrav! Mislim da si ti izvrstan kandidat za slobodno radno mjesto u našem poduzeću i bilo bi mi drago dati ti svoju osobnu preporuku.',
      hu_HU: 'Hello! Szerintem ideális jelölt lennél a cégem egy nyitott pozíciójára és örömmel be is ajánlanálak.',
      it_IT:
        'Ciao! Penso che tu sia un candidato perfetto per una posizione aperta presso la mia azienda e mi piacerebbe darti una segnalazione personale.',
      nl_NL:
        'Hallo! Ik denk dat jij een uitstekende kandidaat zou zijn voor een vacature bij mijn bedrijf. Ik wil je met plezier persoonlijk aanbevelen.',
      pl_PL:
        'Witaj! Myślę, że jesteś świetnym kandydatem na stanowisko w mojej firmie. Osobiście chciałbym Ci wystawić referencje.',
      pt_PT:
        'Olá! Considero-te um(a) candidato(a) fantástico(a) para uma posição aberta na minha empresa e gostaria de te oferecer a minha recomendação pessoal.',
      ro_RO:
        'Bună! Cred că ești un candidat foarte bun pentru o poziție disponibilă în cadrul companiei mele și mi-ar face plăcere să te recomand persona',
      sk_SK:
        'Zdravím! Myslím si, že ste skvelým uchádzačom na voľnú pracovnú ponuku v mojej spoločnosti a rád by som vám poskytol moje osobné odporúčanie.',
      tr_TR:
        'Selam! Şirketimdeki açık bir pozisyon için harika bir aday olduğunuzu düşünüyorum ve size kişisel tavsiyemi vermekten memnuniyet duyarım.',
      th_TH:
        'สวัสดี! ฉันคิดว่าคุณเป็นผู้สมัครที่ดีสำหรับตำแหน่งงานว่างที่บริษัทของฉัน และฉันยินดีที่จะให้คำแนะนำส่วนตัวแก่คุณ',
      zh_CN: '您好！我的公司正在公开招募的一个职位刚好适合您，我很乐意通过我的个人推荐来帮助您获得这个职位。',
      ja_JP: 'こんにちは！私はあなたが私の会社の空席に最適な候補者だと考えています。喜んで私自身の推薦を提供します。'
    }
  },
  DEFAULT_REGISTRATION_TEXTS: {
    ak_GH: {
      headingText: 'Werden Sie ein {{company}} Talent Scout!',
      welcomeText:
        'Nutzen Sie Ihre Chance! Werden Sie zum Headhunter für {{company}} und aktivieren Sie Ihr persönliches Netzwerk von Freunden, Schul- oder Arbeitskollegen. Das Beste daran, Ihr Mitwirken ist gefragt und Sie erhalten tolle Prämien!'
    },
    bg_BG: {
      headingText: 'Станете {{company}} търсач на таланти!',
      welcomeText:
        'Имате шанс сега! Станете хедхънтър за {{company}} и препоръчвайте кандидати от личната си мрежа с приятели, състуденти или колеги за позиции в компанията Ви. Най-хубавото е, че Вашите препоръки щ бъдат високо оценени и може да получите възнаграждение за тях!'
    },
    cs_CZ: {
      headingText: 'Staň se hledačem talentů ve společnosti {{company}}!',
      welcomeText:
        'Přišla tvoje šance! Staň se lovcem talentů pro společnost {{company}} a doporučuj uchazeče ze své soukromé sítě přátel, absolventů a kolegů na pozice ve tvé společnosti. Nejlepší na tom je, že za doporučení můžeš dokonce získat odměny!'
    },
    de_DE: {
      headingText: 'Werde ein {{company}} Talent Scout!',
      welcomeText:
        'Nutze deine Chance! Werde zum Headhunter für {{company}} und aktiviere dein persönliches Netzwerk von Freunden, Schul- oder Arbeitskollegen. Das Beste daran, dein Mitwirken ist gefragt und du erhältst tolle Prämien!'
    },
    en_US: {
      headingText: 'Become a {{company}} Talent Scout!',
      welcomeText:
        'Your chance is here! Become a headhunter for {{company}} and refer candidates from your personal network of friends, alumni or colleagues for jobs at your company. The best part is your referrals will be highly valued, and you may even be rewarded!'
    },
    es_ES: {
      headingText: '¡Conviértete en Talent Scout de {{company}}!',
      welcomeText:
        '¡Esta es tu oportunidad! Hazte Talent Scout de {{company}} y recomienda a candidatos de tu red personal de amigos, alumnos o colegas para puestos en tu empresa. Lo mejor es que tus recomendaciones serán muy valoradas, ¡y podrás incluso obtener recompensas!'
    },
    fi_FI: {
      headingText: 'Ryhdy {{company}} Talent Scoutiksi!',
      welcomeText:
        'Mahdollisuutesi on täällä! Ryhdy {{company}} päänmetsästäjäksi ja ohjaa hakijoita henkilökohtaisesta ystäväverkostostasi, alumneistasi tai kollegoistasi töihin yritykseesi. Parasta on, että suosituksiasi arvostetaan suuresti, ja saatat jopa saada palkkion!'
    },
    fr_FR: {
      headingText: 'Devenez un {{company}} Talent Scout!',
      welcomeText:
        'Voici votre chance: devenez un chasseur de tête pour {{company}}, et recommandez des candidats de votre propre réseau d’amis, d’anciens étudiants et de collègues aux postes libres dans votre entreprise. Ce qui est rassurant, c’est que vos recommandations seront fort appréciées et que vous pourrez éventuellement obtenir une prime.'
    },
    ko_KR: {
      headingText: '{{company}} 인재 스카우트가 되세요!',
      welcomeText:
        '당신의 기회가 여기에 있습니다! {{company}}의 헤드헌터가 되어 친구, 동문 또는 동료의 개인 네트워크에서 후보자를 회사에서 채용하도록 추천하십시오. 가장 좋은 점은 귀하의 추천이 높게 평가되고 보상을 받을 수도 있다는 것입니다!'
    },
    hr_HR: {
      headingText: 'Postani Talent Scout za {{company}}!',
      welcomeText:
        'Evo prilike za tebe! Postani lovac na talente za tvrtku {{company}} i predloži kandidate iz svoje vlastite mreže prijatelja, kolega iz škole, sa studija ili s posla za radna mjesta u svojem poduzeću. Najbolje od svega je da će tvoje preporuke biti visoko cijenjene, a možda ćeš dobiti i nagradu!'
    },
    hu_HU: {
      headingText: 'Legyél Te is egy {{company}} Talent Scout!',
      welcomeText:
        'Itt van a lehetőség! Legyél Te is a/az {{company}} fejvadásza és ajánlj potenciális jelölteket baráti társaságodból, illetve egyetemi társaid vagy régi munkatársaid közül. Az egészben a legjobb az, hogy jelöléseidet értékelni fogjuk és akár még jutalmat is kaphatsz értük!'
    },
    it_IT: {
      headingText: 'Diventa un Talent Scout per {{company}}!',
      welcomeText:
        'La tua possibilità è qui! Diventa un reclutatore per {{company}} e segnala candidati appartenenti alla tua rete personale di amici, studenti o colleghi per le offerte di lavoro presso la tua azienda. Le tue segnalazioni sono preziose e potresti essere premiato!'
    },
    nl_NL: {
      headingText: 'Word een Talent Scout voor {{company}}!',
      welcomeText:
        'Dit is je kans! Word headhunter voor {{company}}, zodat je mensen uit je persoonlijke netwerk van vrienden, collega&#39;s en voormalige medestudenten kunt aanbevelen als kandidaten voor vacatures bij je bedrijf. Je aanbevelingen worden heel erg op prijs gesteld, en je krijgt er misschien zelfs een beloning voor!'
    },
    pl_PL: {
      headingText: 'Zostań Łowcą Talentów firmy {{company}}!',
      welcomeText:
        'To Twoja szansa! Zostań łowcą głów dla {{company}} i zgłaszaj kandydatów spośród grona swoich przyjaciół, absolwentów i znajomych na stanowiska pracy w Twojej firmie. Najlepsze jest to, że osoby, które polecisz mogą być bardzo cenne i za to możesz otrzymać nagrodę!'
    },
    pt_PT: {
      headingText: 'Torna-te um Caçador de Talentos da {{company}}!',
      welcomeText:
        'A tua oportunidade chegou! Torna-te um Caçador de Talentos para a {{company}} e recomenda candidatos da tua rede pessoal de amigos ou colegas para posições na tua empresa. A melhor parte é que as tuas recomendações serão altamente valorizadas e até poderás ser recompensado!'
    },
    ro_RO: {
      headingText: 'Devino un Talent Scout {{company}}!',
      welcomeText:
        'Aceasta este șansa ta! Devino un headhunter pentru {{company}} și recomandă candidați din rețeaua ta de socializare, foști colegi de școală sau de serviciu pentru job-uri în cadrul companiei tale. În plus, recomandările tale vor fi foarte apreciate și poți fi chiar recompensat/ă'
    },
    sk_SK: {
      headingText: 'Staňte sa vyhľadávačom talentov pre spoločnosť {{company}}!',
      welcomeText:
        'Vaša šanca je tu! Staňte sa náborovým pracovníkom pre spoločnosť {{company}} a odporučte uchádzačov z vašej osobnej siete priateľov, absolventov alebo kolegov na prácu vo svojej spoločnosti. Najlepšie je, že vaše odporúčania budú veľmi cenné, a dokonca môžete byť odmenený!'
    },
    tr_TR: {
      headingText: 'Bir {{company}} Yetenek Avcısı olun!',
      welcomeText:
        'Şansın burada! {{company}} için beyin avcısı olun ve şirketinizdeki işler için kişisel arkadaşlarınızdan, mezunlarınızdan veya iş arkadaşlarınızdan adayları yönlendirin. En iyi yanı, yönlendirmelerinize çok değer verilecek ve hatta ödüllendirilebileceksiniz!'
    },
    th_TH: {
      headingText: 'มาเป็น {{company}} Talent Scout!',
      welcomeText:
        'โอกาสของคุณมาถึงแล้ว! มาเป็นหัวหน้าฮันเตอร์ให้กับ {{company}} และแนะนำผู้สมัครจากเครือข่ายส่วนตัวของเพื่อน ศิษย์เก่า หรือเพื่อนร่วมงานเพื่องานที่บริษัทของคุณ ส่วนที่ดีที่สุดคือการอ้างอิงของคุณจะมีมูลค่าสูงและคุณอาจได้รับรางวัล!'
    },
    zh_CN: {
      headingText: '成为{{company}}的人才猎头！',
      welcomeText:
        '机不可失！成为{{company}}的人才猎头，向您的朋友、校友或同行推荐您所在公司的职位吧。您的推荐将受到高度重视，甚至还能让您有所回报！'
    },
    ja_JP: {
      headingText: '{{company}}の人材スカウトになろう!',
      welcomeText:
        'チャンス到来！{{company}}のヘッドハンターになり、友達、同窓生、または同僚のパーソナルネットワークから候補者を紹介しませんか？一番の魅力は、あなたの紹介が非常に評価され、報酬がもらえるかもしれないことです'
    }
  },
  FEATURE_FLAGGED_LANGUAGES,
  JOB_EXPIRING_TIME: 259200000, // 3 days
  JOB_STATUS: {
    ACTIVE_CLOSED: 'ACTIVE_CLOSED',
    ACTIVE_PUBLISHED: 'ACTIVE_PUBLISHED',
    ARCHIVED: 'ARCHIVED',
    DELETED: 'DELETED',
    DRAFT: 'DRAFT'
  },
  INFINITE_DROPDOWN_LIMIT: 25,
  LANGUAGES,
  LEADERBOARD_PERIODS: ['ALL_TIME', 'MONTHLY', 'QUARTERLY', 'SEMI_ANNUALLY', 'YEARLY'],
  LEGAL_TERMS_LANGUAGES,
  LIST_UPDATE_REASON: {
    CLONE: 'CLONE',
    STATUS_CHANGE: 'STATUS_CHANGE'
  },
  MOBILE_APP_CUSTOM_URL: 'fb2go://',
  NOTIFICATION_TYPE: {
    JOB_APPLICATION_UNREFERRED: 'unreferredJobApplications'
  },
  PASSWORD_POLICIES: [
    {
      name: 'HIGH',
      attempts_until_lockout: 5,
      characteristics: ['MIXED_CASE', 'NUMBERS', 'SPECIAL_CHARACTERS'], // Keep alphabetic order
      minimum_length: 10,
      reuse_after_passwords: 5
    },
    {
      name: 'MEDIUM',
      attempts_until_lockout: 5,
      characteristics: ['MIXED_CASE', 'NUMBERS', 'SPECIAL_CHARACTERS'], // Keep alphabetic order
      minimum_length: 8
    },
    {
      name: 'LOW',
      attempts_until_lockout: 5,
      characteristics: [],
      minimum_length: 6
    }
  ],
  PASSWORD_POLICY_CHARACTERISTIC: {
    MIXED_CASE: 'MIXED_CASE',
    NUMBERS: 'NUMBERS',
    NUMBERS_AND_SPECIAL_CHARACTERS: 'NUMBERS_AND_SPECIAL_CHARACTERS',
    SPECIAL_CHARACTERS: 'SPECIAL_CHARACTERS'
  },
  PRICING_PLANS: {
    free: 'free',
    trial: 'trial',
    enterprise: 'enterprise'
  },
  PUBLIC_BASE: '',
  REFERRAL_ICONS: {
    NEGATIVE: 'thumb-down',
    NEUTRAL: 'tilde',
    REFERRAL: 'thumb-up',
    POSITIVE: 'thumb-up'
  },
  REFERRAL_TYPE: {
    NEGATIVE: 'NEGATIVE',
    NEUTRAL: 'NEUTRAL',
    REFERRAL: 'REFERRAL'
  },
  REWARD_STATUS: {
    HIDDEN: 'HIDDEN',
    DELETING: 'DELETING',
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED'
  },
  ROLE_HIERARCHY: {
    ROLE_TALENT_SCOUT: 0,
    ROLE_RECRUITER: 1,
    ROLE_COMPANY_ADMIN: 2
  },
  USER_ROLES: {
    COMPANY_ADMIN: 'ROLE_COMPANY_ADMIN',
    RECRUITER: 'ROLE_RECRUITER',
    TALENT_SCOUT: 'ROLE_TALENT_SCOUT'
  },
  USER_DELETE_REASONS: {
    DONT_WANT_REFERRAL_PROGRAM: 'DONT_WANT_REFERRAL_PROGRAM',
    MISTAKEN_REGISTRATION: 'MISTAKEN_REGISTRATION',
    GOT_SPAMMED: 'GOT_SPAMMED',
    NO_REASON: 'NO_REASON'
  },
  WEB_LINKS: {
    HELP: {
      EN: 'http://get.radancy.help'
    },
    PERMISSIONS: {
      DE: 'https://get.radancy.help/hc/de/articles/115000720305-Erlaubnis-zu-empfehlen',
      EN: 'https://get.radancy.help/hc/en-us/articles/115000720305-Permission-to-Refer'
    },
    PRIVACY_POLICY: 'https://www.radancy.com/en/privacy',
    TERMS_SERVICE: 'https://www.radancy.com/en/terms-and-conditions',
    IMPRINT: 'https://www.radancy.com/en/our-offices',
    COOKIES: {
      DE: 'https://get.radancy.help/hc/de/articles/360001785237-Cookies-und-Plug-ins-die-Firstbird-verwendet',
      EN: 'https://get.radancy.help/hc/en-us/articles/360001785237-Cookies-and-Plug-ins-Firstbird-is-using'
    },
    REWARD_PLAN_HELP: {
      DE: 'https://get.radancy.help/hc/de/articles/115000377285-Pr%C3%A4mieneinstellungen',
      EN: 'https://get.radancy.help/hc/en-us/articles/115000377285-Rewards'
    },
    REWARD_SHOP_ACTIVITIES: {
      DE: 'https://get.radancy.help/hc/de/articles/115000449165-Pr%C3%A4miengestaltung#scroll_id_Punkte',
      EN: 'https://get.radancy.help/hc/en-us/articles/115000449165-Rewarding#scroll_id_Points'
    },
    REWARD_NOTIFICATIONS: {
      DE: 'https://get.radancy.help/hc/de/articles/360019110998-Pr%C3%A4mienbenachrichtigung',
      EN: 'https://get.radancy.help/hc/en-us/articles/360019110998-Reward-Notification'
    },
    REWARD_SHOP_HELP: {
      DE: 'https://get.radancy.help/hc/de/articles/360002145217-Pr%C3%A4mienshop',
      EN: 'https://get.radancy.help/hc/en-us/articles/360002145217-Reward-Shop'
    },
    REWARD_SHOP_LEVEL: {
      DE: 'https://get.radancy.help/hc/de/articles/115000394965-Pr%C3%A4miengestaltung#scroll_id_Level',
      EN: 'https://get.radancy.help/hc/en-us/articles/115000394965-Rewarding#scroll_id_Level'
    },
    SLACK_SUPPORT: {
      DE: 'https://get.radancy.help/hc/de/articles/360017141917-Slack',
      EN: 'https://get.radancy.help/hc/en-us/articles/360017141917-Slack'
    },
    GREENHOUSE_DOCUMENTATION: {
      DE: 'https://get.radancy.help/hc/de/articles/360017923858-Greenhouse',
      EN: 'https://get.radancy.help/hc/en-us/articles/360017923858-Greenhouse'
    },
    API_BROCHURE: {
      DE: 'https://docs.1brd.com/',
      EN: 'https://docs.1brd.com/'
    },
    SAML_HELP: {
      DE: 'https://get.radancy.help/hc/de/articles/360016838558-Single-Sign-on-SSO-',
      EN: 'https://get.radancy.help/hc/en-us/articles/360016838558-Single-Sign-on-SSO-'
    },
    COMPANY_BRANDING: {
      DE: 'https://get.radancy.help/hc/de/articles/115000368649-Branding',
      EN: 'https://get.radancy.help/hc/en-us/articles/115000368649-Company-Branding'
    },
    COMPANY_BRANDED_REGISTRATION: {
      DE: 'https://get.radancy.help/hc/de/articles/115000368649-Branding',
      EN: 'https://get.radancy.help/hc/articles/115000368649-Branding'
    },
    SUPPORT: {
      DE: 'https://get.radancy.help/hc/de/requests/new',
      EN: 'https://get.radancy.help/hc/en-us/requests/new'
    }
  },
  WYSIWYG_VIMEO_EMBED: /^https?:\/\/player\.vimeo\.com\/video\/\d+\/$/,
  WYSIWYG_YOUTUBE_EMBED: /^https?:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]+/,
  COLOR_THEMES: [
    {
      name: 'DEFAULT',
      button: '#1FB6FF'
    }
  ],
  COUNTRIES: {
    AF: 'Afghanistan',
    AX: 'Åland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia (Plurinational State of)',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Côte d'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czechia',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran (Islamic Republic of)',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea (Democratic People's Republic of)",
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia (Federated States of)',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MK: 'North Macedonia',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan, Province of China',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom of Great Britain and Northern Ireland',
    US: 'United States of America',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela (Bolivarian Republic of)',
    VN: 'Viet Nam',
    VG: 'Virgin Islands (British)',
    VI: 'Virgin Islands (U.S.)',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  CURRENCIES: [
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'USD', symbol: '$', name: 'United States dollar' },
    { code: 'GBP', symbol: '£', name: 'British pound' },
    { code: 'AFN', symbol: '؋', name: 'Afghan afghani' },
    { code: 'ALL', symbol: 'Lek', name: 'Albanian lek' },
    { code: 'DZD', symbol: 'دج', name: 'Algerian dinar' },
    { code: 'AOA', symbol: 'Kz', name: 'Angolan kwanza' },
    { code: 'ARS', symbol: '$m/n', name: 'Argentine peso' },
    { code: 'AMD', symbol: '֏', name: 'Armenian dram' },
    { code: 'AWG', symbol: 'ƒ', name: 'Aruban florin' },
    { code: 'AUD', symbol: 'A$', name: 'Australian dollar' },
    { code: 'AZN', symbol: '₼', name: 'Azerbaijani manat' },
    { code: 'BSD', symbol: 'BSD', name: 'Bahamian dollar' },
    { code: 'BHD', symbol: '.د.ب', name: 'Bahraini dinar' },
    { code: 'BDT', symbol: '৳', name: 'Bangladeshi taka' },
    { code: 'BBD', symbol: 'Bds$', name: 'Barbadian dollar' },
    { code: 'BYN', symbol: 'BYN', name: 'Belarusian ruble' },
    { code: 'BZD', symbol: 'BZ$', name: 'Belize dollar' },
    { code: 'BMD', symbol: 'BD$', name: 'Bermudian dollar' },
    { code: 'BTN', symbol: 'Nu.', name: 'Bhutanese ngultrum' },
    { code: 'BOB', symbol: 'Bs.', name: 'Bolivian boliviano' },
    { code: 'BAM', symbol: 'КМ', name: 'Bosnia and Herzegovina convertible mark' },
    { code: 'BWP', symbol: 'P', name: 'Botswana pula' },
    { code: 'BRL', symbol: 'R$', name: 'Brazilian real' },
    { code: 'BND', symbol: 'BND', name: 'Brunei dollar' },
    { code: 'BGN', symbol: 'лв.', name: 'Bulgarian lev' },
    { code: 'BIF', symbol: 'FBu', name: 'Burundian franc' },
    { code: 'XPF', symbol: 'Fr', name: 'CFP franc' },
    { code: 'KHR', symbol: '៛', name: 'Cambodian riel' },
    { code: 'CAD', symbol: 'C$', name: 'Canadian dollar' },
    { code: 'CVE', symbol: 'Esc', name: 'Cape Verdean escudo' },
    { code: 'KYD', symbol: 'CI$', name: 'Cayman Islands dollar' },
    { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA franc' },
    { code: 'CLP', symbol: 'CLP', name: 'Chilean peso' },
    { code: 'CNY', symbol: '¥', name: 'Chinese renminbi yuan' },
    { code: 'COP', symbol: 'COL$', name: 'Colombian peso' },
    { code: 'KMF', symbol: 'CF', name: 'Comorian franc' },
    { code: 'CDF', symbol: 'FC', name: 'Congolese franc' },
    { code: 'CRC', symbol: '₡', name: 'Costa Rican colón' },
    { code: 'HRK', symbol: 'kn', name: 'Croatian kuna' },
    { code: 'CUC', symbol: 'CUC$', name: 'Cuban convertible peso' },
    { code: 'CUP', symbol: '$MN', name: 'Cuban peso' },
    { code: 'CZK', symbol: 'Kč', name: 'Czech koruna' },
    { code: 'DKK', symbol: 'DKK', name: 'Danish krone' },
    { code: 'DJF', symbol: 'Fdj', name: 'Djiboutian franc' },
    { code: 'DOP', symbol: 'RD$', name: 'Dominican peso' },
    { code: 'XCD', symbol: 'EX$', name: 'Eastern Caribbean dollar' },
    { code: 'EGP', symbol: 'ج.م', name: 'Egyptian pound' },
    { code: 'ERN', symbol: 'Nfk', name: 'Eritrean nakfa' },
    { code: 'ETB', symbol: 'ETB', name: 'Ethiopian birr' },
    { code: 'FKP', symbol: 'FK£', name: 'Falkland Islands pound' },
    { code: 'FJD', symbol: 'FJ$', name: 'Fijian dollar' },
    { code: 'GMD', symbol: 'D', name: 'Gambian dalasi' },
    { code: 'GEL', symbol: '₾', name: 'Georgian lari' },
    { code: 'GHS', symbol: '₵', name: 'Ghanaian cedi' },
    { code: 'GIP', symbol: 'GIP', name: 'Gibraltar pound' },
    { code: 'GTQ', symbol: 'Q', name: 'Guatemalan quetzal' },
    { code: 'GNF', symbol: 'FG', name: 'Guinean franc' },
    { code: 'GYD', symbol: 'G$', name: 'Guyanese dollar' },
    { code: 'HTG', symbol: 'G', name: 'Haitian gourde' },
    { code: 'HNL', symbol: 'HNL', name: 'Honduran lempira' },
    { code: 'HKD', symbol: 'HK$', name: 'Hong Kong dollar' },
    { code: 'HUF', symbol: 'Ft', name: 'Hungarian forint' },
    { code: 'ISK', symbol: 'kr', name: 'Icelandic króna' },
    { code: 'INR', symbol: '₹', name: 'Indian rupee' },
    { code: 'IDR', symbol: 'Rp', name: 'Indonesian rupiah' },
    { code: 'IRR', symbol: '﷼', name: 'Iranian rial' },
    { code: 'IQD', symbol: 'د.ع', name: 'Iraqi dinar' },
    { code: 'ILS', symbol: '₪', name: 'Israeli new shekel' },
    { code: 'JMD', symbol: 'J$', name: 'Jamaican dollar' },
    { code: 'JPY', symbol: '¥', name: 'Japanese yen' },
    { code: 'JOD', symbol: 'د.ا', name: 'Jordanian dinar' },
    { code: 'KZT', symbol: '₸', name: 'Kazakhstani tenge' },
    { code: 'KES', symbol: 'KSh', name: 'Kenyan shilling' },
    { code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti dinar' },
    { code: 'KGS', symbol: 'som', name: 'Kyrgyzstani som' },
    { code: 'LAK', symbol: '₭', name: 'Lao kip' },
    { code: 'LBP', symbol: 'ل.ل', name: 'Lebanese pound' },
    { code: 'LSL', symbol: 'M', name: 'Lesotho loti' },
    { code: 'LRD', symbol: 'L$', name: 'Liberian dollar' },
    { code: 'LYD', symbol: 'ل.د', name: 'Libyan dinar' },
    { code: 'MOP', symbol: 'MOP$', name: 'Macanese pataca' },
    { code: 'MKD', symbol: 'ден', name: 'Macedonian denar' },
    { code: 'MGA', symbol: 'Ar', name: 'Malagasy ariary' },
    { code: 'MWK', symbol: 'MK', name: 'Malawian kwacha' },
    { code: 'MYR', symbol: 'RM', name: 'Malaysian ringgit' },
    { code: 'MVR', symbol: 'MVR', name: 'Maldivian rufiyaa' },
    { code: 'MRO', symbol: 'UM', name: 'Mauritanian ouguiya' },
    { code: 'MUR', symbol: '₨', name: 'Mauritian rupee' },
    { code: 'MXN', symbol: 'MEX$', name: 'Mexican peso' },
    { code: 'MDL', symbol: 'L', name: 'Moldovan leu' },
    { code: 'MNT', symbol: '₮', name: 'Mongolian tögrög' },
    { code: 'MAD', symbol: 'د.م.', name: 'Moroccan dirham' },
    { code: 'MZN', symbol: 'MTn', name: 'Mozambican metical' },
    { code: 'MMK', symbol: 'MMK', name: 'Myanmar kyat' },
    { code: 'NAD', symbol: 'N$', name: 'Namibian dollar' },
    { code: 'NPR', symbol: 'रु', name: 'Nepalese rupee' },
    { code: 'ANG', symbol: 'NAƒ', name: 'Netherlands Antillean guilder' },
    { code: 'TWD', symbol: 'NT$', name: 'New Taiwan dollar' },
    { code: 'NZD', symbol: 'NZ$', name: 'New Zealand dollar' },
    { code: 'NIO', symbol: 'NIO$', name: 'Nicaraguan córdoba' },
    { code: 'NGN', symbol: '₦', name: 'Nigerian naira' },
    { code: 'KPW', symbol: '₩', name: 'North Korean won' },
    { code: 'NOK', symbol: 'NOK', name: 'Norwegian krone' },
    { code: 'OMR', symbol: '﷼', name: 'Omani rial' },
    { code: 'PKR', symbol: 'PKR', name: 'Pakistani rupee' },
    { code: 'PAB', symbol: 'B/.', name: 'Panamanian balboa' },
    { code: 'PGK', symbol: 'PGK', name: 'Papua New Guinean kina' },
    { code: 'PYG', symbol: '₲', name: 'Paraguayan guaraní' },
    { code: 'PEN', symbol: 'S/.', name: 'Peruvian sol' },
    { code: 'PHP', symbol: '₱', name: 'Philippine peso' },
    { code: 'PLN', symbol: 'zł', name: 'Polish złoty' },
    { code: 'QAR', symbol: 'ر.ق', name: 'Qatari riyal' },
    { code: 'RON', symbol: 'lei', name: 'Romanian leu' },
    { code: 'RUB', symbol: '₽', name: 'Russian ruble' },
    { code: 'RWF', symbol: 'FRw', name: 'Rwandan franc' },
    { code: 'SHP', symbol: 'SHP', name: 'Saint Helenian pound' },
    { code: 'WST', symbol: 'WS$', name: 'Samoan tālā' },
    { code: 'STD', symbol: 'Db', name: 'São Tomé and Príncipe dobra' },
    { code: 'SAR', symbol: 'SR', name: 'Saudi riyal' },
    { code: 'RSD', symbol: 'РСД', name: 'Serbian dinar' },
    { code: 'SCR', symbol: 'SRe', name: 'Seychellois rupee' },
    { code: 'SLL', symbol: 'Le', name: 'Sierra Leonean leone' },
    { code: 'SGD', symbol: 'S$', name: 'Singapore dollar' },
    { code: 'SBD', symbol: 'SI$', name: 'Solomon Islands dollar' },
    { code: 'SOS', symbol: 'Sh', name: 'Somali shilling' },
    { code: 'ZAR', symbol: 'R', name: 'South African rand' },
    { code: 'KRW', symbol: '₩', name: 'South Korean won' },
    { code: 'SSP', symbol: 'SSP', name: 'South Sudanese pound' },
    { code: 'LKR', symbol: 'රු', name: 'Sri Lankan rupee' },
    { code: 'SDG', symbol: 'SDG', name: 'Sudanese pound' },
    { code: 'SRD', symbol: 'SRD', name: 'Surinamese dollar' },
    { code: 'SZL', symbol: 'SZL', name: 'Swazi lilangeni' },
    { code: 'SEK', symbol: 'SEK', name: 'Swedish krona' },
    { code: 'CHF', symbol: 'CHF', name: 'Swiss franc' },
    { code: 'SYP', symbol: '£S', name: 'Syrian pound' },
    { code: 'TJS', symbol: 'ЅМ', name: 'Tajikistani somoni' },
    { code: 'TZS', symbol: 'Sh', name: 'Tanzanian shilling' },
    { code: 'THB', symbol: '฿', name: 'Thai baht' },
    { code: 'TOP', symbol: 'T$', name: 'Tongan paʻanga' },
    { code: 'TTD', symbol: 'TT$', name: 'Trinidad and Tobago dollar' },
    { code: 'TND', symbol: 'د.ت', name: 'Tunisian dinar' },
    { code: 'TRY', symbol: '₺', name: 'Turkish lira' },
    { code: 'TMT', symbol: 'T', name: 'Turkmenistani manat' },
    { code: 'UGX', symbol: 'USh', name: 'Ugandan shilling' },
    { code: 'UAH', symbol: '₴', name: 'Ukrainian hryvnia' },
    { code: 'AED', symbol: 'د.إ', name: 'United Arab Emirates dirham' },
    { code: 'UYU', symbol: '$U', name: 'Uruguayan peso' },
    { code: 'UZS', symbol: 'so‘m', name: 'Uzbekistani soʻm' },
    { code: 'VUV', symbol: 'Vt', name: 'Vanuatu vatu' },
    { code: 'VEF', symbol: 'Bs.F.', name: 'Venezuelan bolívar' },
    { code: 'VND', symbol: '₫', name: 'Vietnamese đồng' },
    { code: 'XOF', symbol: 'CFA', name: 'West African CFA franc' },
    { code: 'YER', symbol: '﷼', name: 'Yemeni rial' },
    { code: 'ZMW', symbol: 'ZMW', name: 'Zambian kwacha' },
    { code: 'ZWL', symbol: 'Z$', name: 'Zimbabwean dollar' },
    { code: 'XRP', symbol: 'RP', name: 'Reward points' }
  ],
  TIMEZONES: [
    // fetched and prettified from http://api.timezonedb.com/v2/list-time-zone?key=T2FZMZHD4L96&format=json
    { countryCode: 'AD', zoneName: 'Europe/Andorra', suffix: '(UTC/GMT +2)' },
    { countryCode: 'AE', zoneName: 'Asia/Dubai', suffix: '(UTC/GMT +4)' },
    { countryCode: 'AF', zoneName: 'Asia/Kabul', suffix: '(UTC/GMT +4.5)' },
    { countryCode: 'AG', zoneName: 'America/Antigua', suffix: '(UTC/GMT -4)' },
    { countryCode: 'AI', zoneName: 'America/Anguilla', suffix: '(UTC/GMT -4)' },
    { countryCode: 'AL', zoneName: 'Europe/Tirane', suffix: '(UTC/GMT +2)' },
    { countryCode: 'AM', zoneName: 'Asia/Yerevan', suffix: '(UTC/GMT +4)' },
    { countryCode: 'AO', zoneName: 'Africa/Luanda', suffix: '(UTC/GMT +1)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Casey', suffix: '(UTC/GMT +8)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Davis', suffix: '(UTC/GMT +7)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/DumontDUrville', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Mawson', suffix: '(UTC/GMT +5)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/McMurdo', suffix: '(UTC/GMT +12)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Palmer', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Rothera', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Syowa', suffix: '(UTC/GMT +3)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Troll', suffix: '(UTC/GMT +2)' },
    { countryCode: 'AQ', zoneName: 'Antarctica/Vostok', suffix: '(UTC/GMT +6)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Buenos_Aires', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Catamarca', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Cordoba', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Jujuy', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/La_Rioja', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Mendoza', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Rio_Gallegos', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Salta', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/San_Juan', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/San_Luis', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Tucuman', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AR', zoneName: 'America/Argentina/Ushuaia', suffix: '(UTC/GMT -3)' },
    { countryCode: 'AS', zoneName: 'Pacific/Pago_Pago', suffix: '(UTC/GMT -11)' },
    { countryCode: 'AT', zoneName: 'Europe/Vienna', suffix: '(UTC/GMT +2)' },
    { countryCode: 'AU', zoneName: 'Antarctica/Macquarie', suffix: '(UTC/GMT +11)' },
    { countryCode: 'AU', zoneName: 'Australia/Adelaide', suffix: '(UTC/GMT +9.5)' },
    { countryCode: 'AU', zoneName: 'Australia/Brisbane', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AU', zoneName: 'Australia/Broken_Hill', suffix: '(UTC/GMT +9.5)' },
    { countryCode: 'AU', zoneName: 'Australia/Currie', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AU', zoneName: 'Australia/Darwin', suffix: '(UTC/GMT +9.5)' },
    { countryCode: 'AU', zoneName: 'Australia/Eucla', suffix: '(UTC/GMT +8.75)' },
    { countryCode: 'AU', zoneName: 'Australia/Hobart', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AU', zoneName: 'Australia/Lindeman', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AU', zoneName: 'Australia/Lord_Howe', suffix: '(UTC/GMT +10.5)' },
    { countryCode: 'AU', zoneName: 'Australia/Melbourne', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AU', zoneName: 'Australia/Perth', suffix: '(UTC/GMT +8)' },
    { countryCode: 'AU', zoneName: 'Australia/Sydney', suffix: '(UTC/GMT +10)' },
    { countryCode: 'AW', zoneName: 'America/Aruba', suffix: '(UTC/GMT -4)' },
    { countryCode: 'AZ', zoneName: 'Asia/Baku', suffix: '(UTC/GMT +4)' },
    { countryCode: 'BA', zoneName: 'Europe/Sarajevo', suffix: '(UTC/GMT +2)' },
    { countryCode: 'BB', zoneName: 'America/Barbados', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BD', zoneName: 'Asia/Dhaka', suffix: '(UTC/GMT +6)' },
    { countryCode: 'BE', zoneName: 'Europe/Brussels', suffix: '(UTC/GMT +2)' },
    { countryCode: 'BF', zoneName: 'Africa/Ouagadougou', suffix: '(UTC/GMT 0)' },
    { countryCode: 'BG', zoneName: 'Europe/Sofia', suffix: '(UTC/GMT +3)' },
    { countryCode: 'BH', zoneName: 'Asia/Bahrain', suffix: '(UTC/GMT +3)' },
    { countryCode: 'BI', zoneName: 'Africa/Bujumbura', suffix: '(UTC/GMT +2)' },
    { countryCode: 'BJ', zoneName: 'Africa/Porto-Novo', suffix: '(UTC/GMT +1)' },
    { countryCode: 'BM', zoneName: 'Atlantic/Bermuda', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BN', zoneName: 'Asia/Brunei', suffix: '(UTC/GMT +8)' },
    { countryCode: 'BO', zoneName: 'America/La_Paz', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BR', zoneName: 'America/Araguaina', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Bahia', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Belem', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Boa_Vista', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BR', zoneName: 'America/Campo_Grande', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BR', zoneName: 'America/Cuiaba', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BR', zoneName: 'America/Eirunepe', suffix: '(UTC/GMT -5)' },
    { countryCode: 'BR', zoneName: 'America/Fortaleza', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Maceio', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Manaus', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BR', zoneName: 'America/Noronha', suffix: '(UTC/GMT -2)' },
    { countryCode: 'BR', zoneName: 'America/Porto_Velho', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BR', zoneName: 'America/Recife', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Rio_Branco', suffix: '(UTC/GMT -5)' },
    { countryCode: 'BR', zoneName: 'America/Santarem', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BR', zoneName: 'America/Sao_Paulo', suffix: '(UTC/GMT -3)' },
    { countryCode: 'BS', zoneName: 'America/Nassau', suffix: '(UTC/GMT -4)' },
    { countryCode: 'BT', zoneName: 'Asia/Thimphu', suffix: '(UTC/GMT +6)' },
    { countryCode: 'BW', zoneName: 'Africa/Gaborone', suffix: '(UTC/GMT +2)' },
    { countryCode: 'BY', zoneName: 'Europe/Minsk', suffix: '(UTC/GMT +3)' },
    { countryCode: 'BZ', zoneName: 'America/Belize', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CA', zoneName: 'America/Atikokan', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CA', zoneName: 'America/Blanc-Sablon', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CA', zoneName: 'America/Cambridge_Bay', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CA', zoneName: 'America/Creston', suffix: '(UTC/GMT -7)' },
    { countryCode: 'CA', zoneName: 'America/Dawson', suffix: '(UTC/GMT -7)' },
    { countryCode: 'CA', zoneName: 'America/Dawson_Creek', suffix: '(UTC/GMT -7)' },
    { countryCode: 'CA', zoneName: 'America/Edmonton', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CA', zoneName: 'America/Fort_Nelson', suffix: '(UTC/GMT -7)' },
    { countryCode: 'CA', zoneName: 'America/Glace_Bay', suffix: '(UTC/GMT -3)' },
    { countryCode: 'CA', zoneName: 'America/Goose_Bay', suffix: '(UTC/GMT -3)' },
    { countryCode: 'CA', zoneName: 'America/Halifax', suffix: '(UTC/GMT -3)' },
    { countryCode: 'CA', zoneName: 'America/Inuvik', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CA', zoneName: 'America/Iqaluit', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CA', zoneName: 'America/Moncton', suffix: '(UTC/GMT -3)' },
    { countryCode: 'CA', zoneName: 'America/Nipigon', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CA', zoneName: 'America/Pangnirtung', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CA', zoneName: 'America/Rainy_River', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CA', zoneName: 'America/Rankin_Inlet', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CA', zoneName: 'America/Regina', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CA', zoneName: 'America/Resolute', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CA', zoneName: 'America/St_Johns', suffix: '(UTC/GMT -2.5)' },
    { countryCode: 'CA', zoneName: 'America/Swift_Current', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CA', zoneName: 'America/Thunder_Bay', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CA', zoneName: 'America/Toronto', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CA', zoneName: 'America/Vancouver', suffix: '(UTC/GMT -7)' },
    { countryCode: 'CA', zoneName: 'America/Whitehorse', suffix: '(UTC/GMT -7)' },
    { countryCode: 'CA', zoneName: 'America/Winnipeg', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CA', zoneName: 'America/Yellowknife', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CC', zoneName: 'Indian/Cocos', suffix: '(UTC/GMT +6.5)' },
    { countryCode: 'CD', zoneName: 'Africa/Kinshasa', suffix: '(UTC/GMT +1)' },
    { countryCode: 'CD', zoneName: 'Africa/Lubumbashi', suffix: '(UTC/GMT +2)' },
    { countryCode: 'CF', zoneName: 'Africa/Bangui', suffix: '(UTC/GMT +1)' },
    { countryCode: 'CG', zoneName: 'Africa/Brazzaville', suffix: '(UTC/GMT +1)' },
    { countryCode: 'CH', zoneName: 'Europe/Zurich', suffix: '(UTC/GMT +2)' },
    { countryCode: 'CI', zoneName: 'Africa/Abidjan', suffix: '(UTC/GMT 0)' },
    { countryCode: 'CK', zoneName: 'Pacific/Rarotonga', suffix: '(UTC/GMT -10)' },
    { countryCode: 'CL', zoneName: 'America/Santiago', suffix: '(UTC/GMT -3)' },
    { countryCode: 'CL', zoneName: 'Pacific/Easter', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CM', zoneName: 'Africa/Douala', suffix: '(UTC/GMT +1)' },
    { countryCode: 'CN', zoneName: 'Asia/Shanghai', suffix: '(UTC/GMT +8)' },
    { countryCode: 'CN', zoneName: 'Asia/Urumqi', suffix: '(UTC/GMT +6)' },
    { countryCode: 'CO', zoneName: 'America/Bogota', suffix: '(UTC/GMT -5)' },
    { countryCode: 'CR', zoneName: 'America/Costa_Rica', suffix: '(UTC/GMT -6)' },
    { countryCode: 'CU', zoneName: 'America/Havana', suffix: '(UTC/GMT -4)' },
    { countryCode: 'CV', zoneName: 'Atlantic/Cape_Verde', suffix: '(UTC/GMT -1)' },
    { countryCode: 'CX', zoneName: 'Indian/Christmas', suffix: '(UTC/GMT +7)' },
    { countryCode: 'CY', zoneName: 'Asia/Nicosia', suffix: '(UTC/GMT +3)' },
    { countryCode: 'CZ', zoneName: 'Europe/Prague', suffix: '(UTC/GMT +2)' },
    { countryCode: 'DE', zoneName: 'Europe/Berlin', suffix: '(UTC/GMT +2)' },
    { countryCode: 'DE', zoneName: 'Europe/Busingen', suffix: '(UTC/GMT +2)' },
    { countryCode: 'DJ', zoneName: 'Africa/Djibouti', suffix: '(UTC/GMT +3)' },
    { countryCode: 'DK', zoneName: 'Europe/Copenhagen', suffix: '(UTC/GMT +2)' },
    { countryCode: 'DM', zoneName: 'America/Dominica', suffix: '(UTC/GMT -4)' },
    { countryCode: 'DO', zoneName: 'America/Santo_Domingo', suffix: '(UTC/GMT -4)' },
    { countryCode: 'DZ', zoneName: 'Africa/Algiers', suffix: '(UTC/GMT +1)' },
    { countryCode: 'EC', zoneName: 'America/Guayaquil', suffix: '(UTC/GMT -5)' },
    { countryCode: 'EC', zoneName: 'Pacific/Galapagos', suffix: '(UTC/GMT -6)' },
    { countryCode: 'EE', zoneName: 'Europe/Tallinn', suffix: '(UTC/GMT +3)' },
    { countryCode: 'EG', zoneName: 'Africa/Cairo', suffix: '(UTC/GMT +2)' },
    { countryCode: 'EH', zoneName: 'Africa/El_Aaiun', suffix: '(UTC/GMT +1)' },
    { countryCode: 'ER', zoneName: 'Africa/Asmara', suffix: '(UTC/GMT +3)' },
    { countryCode: 'ES', zoneName: 'Africa/Ceuta', suffix: '(UTC/GMT +2)' },
    { countryCode: 'ES', zoneName: 'Atlantic/Canary', suffix: '(UTC/GMT +1)' },
    { countryCode: 'ES', zoneName: 'Europe/Madrid', suffix: '(UTC/GMT +2)' },
    { countryCode: 'ET', zoneName: 'Africa/Addis_Ababa', suffix: '(UTC/GMT +3)' },
    { countryCode: 'FI', zoneName: 'Europe/Helsinki', suffix: '(UTC/GMT +3)' },
    { countryCode: 'FJ', zoneName: 'Pacific/Fiji', suffix: '(UTC/GMT +12)' },
    { countryCode: 'FK', zoneName: 'Atlantic/Stanley', suffix: '(UTC/GMT -3)' },
    { countryCode: 'FM', zoneName: 'Pacific/Chuuk', suffix: '(UTC/GMT +10)' },
    { countryCode: 'FM', zoneName: 'Pacific/Kosrae', suffix: '(UTC/GMT +11)' },
    { countryCode: 'FM', zoneName: 'Pacific/Pohnpei', suffix: '(UTC/GMT +11)' },
    { countryCode: 'FO', zoneName: 'Atlantic/Faroe', suffix: '(UTC/GMT +1)' },
    { countryCode: 'FR', zoneName: 'Europe/Paris', suffix: '(UTC/GMT +2)' },
    { countryCode: 'GA', zoneName: 'Africa/Libreville', suffix: '(UTC/GMT +1)' },
    { countryCode: 'GB', zoneName: 'Europe/London', suffix: '(UTC/GMT +1)' },
    { countryCode: 'GD', zoneName: 'America/Grenada', suffix: '(UTC/GMT -4)' },
    { countryCode: 'GE', zoneName: 'Asia/Tbilisi', suffix: '(UTC/GMT +4)' },
    { countryCode: 'GF', zoneName: 'America/Cayenne', suffix: '(UTC/GMT -3)' },
    { countryCode: 'GH', zoneName: 'Africa/Accra', suffix: '(UTC/GMT 0)' },
    { countryCode: 'GI', zoneName: 'Europe/Gibraltar', suffix: '(UTC/GMT +2)' },
    { countryCode: 'GL', zoneName: 'America/Danmarkshavn', suffix: '(UTC/GMT 0)' },
    { countryCode: 'GL', zoneName: 'America/Godthab', suffix: '(UTC/GMT -2)' },
    { countryCode: 'GL', zoneName: 'America/Scoresbysund', suffix: '(UTC/GMT 0)' },
    { countryCode: 'GL', zoneName: 'America/Thule', suffix: '(UTC/GMT -3)' },
    { countryCode: 'GM', zoneName: 'Africa/Banjul', suffix: '(UTC/GMT 0)' },
    { countryCode: 'GN', zoneName: 'Africa/Conakry', suffix: '(UTC/GMT 0)' },
    { countryCode: 'GP', zoneName: 'America/Guadeloupe', suffix: '(UTC/GMT -4)' },
    { countryCode: 'GQ', zoneName: 'Africa/Malabo', suffix: '(UTC/GMT +1)' },
    { countryCode: 'GR', zoneName: 'Europe/Athens', suffix: '(UTC/GMT +3)' },
    { countryCode: 'GS', zoneName: 'Atlantic/South_Georgia', suffix: '(UTC/GMT -2)' },
    { countryCode: 'GT', zoneName: 'America/Guatemala', suffix: '(UTC/GMT -6)' },
    { countryCode: 'GU', zoneName: 'Pacific/Guam', suffix: '(UTC/GMT +10)' },
    { countryCode: 'GW', zoneName: 'Africa/Bissau', suffix: '(UTC/GMT 0)' },
    { countryCode: 'GY', zoneName: 'America/Guyana', suffix: '(UTC/GMT -4)' },
    { countryCode: 'HK', zoneName: 'Asia/Hong_Kong', suffix: '(UTC/GMT +8)' },
    { countryCode: 'HN', zoneName: 'America/Tegucigalpa', suffix: '(UTC/GMT -6)' },
    { countryCode: 'HR', zoneName: 'Europe/Zagreb', suffix: '(UTC/GMT +2)' },
    { countryCode: 'HT', zoneName: 'America/Port-au-Prince', suffix: '(UTC/GMT -5)' },
    { countryCode: 'HU', zoneName: 'Europe/Budapest', suffix: '(UTC/GMT +2)' },
    { countryCode: 'ID', zoneName: 'Asia/Jakarta', suffix: '(UTC/GMT +7)' },
    { countryCode: 'ID', zoneName: 'Asia/Jayapura', suffix: '(UTC/GMT +9)' },
    { countryCode: 'ID', zoneName: 'Asia/Makassar', suffix: '(UTC/GMT +8)' },
    { countryCode: 'ID', zoneName: 'Asia/Pontianak', suffix: '(UTC/GMT +7)' },
    { countryCode: 'IE', zoneName: 'Europe/Dublin', suffix: '(UTC/GMT +1)' },
    { countryCode: 'IL', zoneName: 'Asia/Jerusalem', suffix: '(UTC/GMT +3)' },
    { countryCode: 'IN', zoneName: 'Asia/Kolkata', suffix: '(UTC/GMT +5.5)' },
    { countryCode: 'IO', zoneName: 'Indian/Chagos', suffix: '(UTC/GMT +6)' },
    { countryCode: 'IQ', zoneName: 'Asia/Baghdad', suffix: '(UTC/GMT +3)' },
    { countryCode: 'IR', zoneName: 'Asia/Tehran', suffix: '(UTC/GMT +4.5)' },
    { countryCode: 'IS', zoneName: 'Atlantic/Reykjavik', suffix: '(UTC/GMT 0)' },
    { countryCode: 'IT', zoneName: 'Europe/Rome', suffix: '(UTC/GMT +2)' },
    { countryCode: 'JM', zoneName: 'America/Jamaica', suffix: '(UTC/GMT -5)' },
    { countryCode: 'JO', zoneName: 'Asia/Amman', suffix: '(UTC/GMT +3)' },
    { countryCode: 'JP', zoneName: 'Asia/Tokyo', suffix: '(UTC/GMT +9)' },
    { countryCode: 'KE', zoneName: 'Africa/Nairobi', suffix: '(UTC/GMT +3)' },
    { countryCode: 'KG', zoneName: 'Asia/Bishkek', suffix: '(UTC/GMT +6)' },
    { countryCode: 'KH', zoneName: 'Asia/Phnom_Penh', suffix: '(UTC/GMT +7)' },
    { countryCode: 'KI', zoneName: 'Pacific/Enderbury', suffix: '(UTC/GMT +13)' },
    { countryCode: 'KI', zoneName: 'Pacific/Kiritimati', suffix: '(UTC/GMT +14)' },
    { countryCode: 'KI', zoneName: 'Pacific/Tarawa', suffix: '(UTC/GMT +12)' },
    { countryCode: 'KM', zoneName: 'Indian/Comoro', suffix: '(UTC/GMT +3)' },
    { countryCode: 'KN', zoneName: 'America/St_Kitts', suffix: '(UTC/GMT -4)' },
    { countryCode: 'KP', zoneName: 'Asia/Pyongyang', suffix: '(UTC/GMT +8.5)' },
    { countryCode: 'KR', zoneName: 'Asia/Seoul', suffix: '(UTC/GMT +9)' },
    { countryCode: 'KW', zoneName: 'Asia/Kuwait', suffix: '(UTC/GMT +3)' },
    { countryCode: 'KY', zoneName: 'America/Cayman', suffix: '(UTC/GMT -5)' },
    { countryCode: 'KZ', zoneName: 'Asia/Almaty', suffix: '(UTC/GMT +6)' },
    { countryCode: 'KZ', zoneName: 'Asia/Aqtau', suffix: '(UTC/GMT +5)' },
    { countryCode: 'KZ', zoneName: 'Asia/Aqtobe', suffix: '(UTC/GMT +5)' },
    { countryCode: 'KZ', zoneName: 'Asia/Oral', suffix: '(UTC/GMT +5)' },
    { countryCode: 'KZ', zoneName: 'Asia/Qyzylorda', suffix: '(UTC/GMT +6)' },
    { countryCode: 'LA', zoneName: 'Asia/Vientiane', suffix: '(UTC/GMT +7)' },
    { countryCode: 'LB', zoneName: 'Asia/Beirut', suffix: '(UTC/GMT +3)' },
    { countryCode: 'LC', zoneName: 'America/St_Lucia', suffix: '(UTC/GMT -4)' },
    { countryCode: 'LI', zoneName: 'Europe/Vaduz', suffix: '(UTC/GMT +2)' },
    { countryCode: 'LK', zoneName: 'Asia/Colombo', suffix: '(UTC/GMT +5.5)' },
    { countryCode: 'LR', zoneName: 'Africa/Monrovia', suffix: '(UTC/GMT 0)' },
    { countryCode: 'LS', zoneName: 'Africa/Maseru', suffix: '(UTC/GMT +2)' },
    { countryCode: 'LT', zoneName: 'Europe/Vilnius', suffix: '(UTC/GMT +3)' },
    { countryCode: 'LU', zoneName: 'Europe/Luxembourg', suffix: '(UTC/GMT +2)' },
    { countryCode: 'LV', zoneName: 'Europe/Riga', suffix: '(UTC/GMT +3)' },
    { countryCode: 'LY', zoneName: 'Africa/Tripoli', suffix: '(UTC/GMT +2)' },
    { countryCode: 'MA', zoneName: 'Africa/Casablanca', suffix: '(UTC/GMT +1)' },
    { countryCode: 'MC', zoneName: 'Europe/Monaco', suffix: '(UTC/GMT +2)' },
    { countryCode: 'MD', zoneName: 'Europe/Chisinau', suffix: '(UTC/GMT +3)' },
    { countryCode: 'ME', zoneName: 'Europe/Podgorica', suffix: '(UTC/GMT +2)' },
    { countryCode: 'MG', zoneName: 'Indian/Antananarivo', suffix: '(UTC/GMT +3)' },
    { countryCode: 'MH', zoneName: 'Pacific/Kwajalein', suffix: '(UTC/GMT +12)' },
    { countryCode: 'MH', zoneName: 'Pacific/Majuro', suffix: '(UTC/GMT +12)' },
    { countryCode: 'MK', zoneName: 'Europe/Skopje', suffix: '(UTC/GMT +2)' },
    { countryCode: 'ML', zoneName: 'Africa/Bamako', suffix: '(UTC/GMT 0)' },
    { countryCode: 'MM', zoneName: 'Asia/Rangoon', suffix: '(UTC/GMT +6.5)' },
    { countryCode: 'MN', zoneName: 'Asia/Choibalsan', suffix: '(UTC/GMT +9)' },
    { countryCode: 'MN', zoneName: 'Asia/Hovd', suffix: '(UTC/GMT +8)' },
    { countryCode: 'MN', zoneName: 'Asia/Ulaanbaatar', suffix: '(UTC/GMT +9)' },
    { countryCode: 'MO', zoneName: 'Asia/Macau', suffix: '(UTC/GMT +8)' },
    { countryCode: 'MP', zoneName: 'Pacific/Saipan', suffix: '(UTC/GMT +10)' },
    { countryCode: 'MQ', zoneName: 'America/Martinique', suffix: '(UTC/GMT -4)' },
    { countryCode: 'MR', zoneName: 'Africa/Nouakchott', suffix: '(UTC/GMT 0)' },
    { countryCode: 'MS', zoneName: 'America/Montserrat', suffix: '(UTC/GMT -4)' },
    { countryCode: 'MT', zoneName: 'Europe/Malta', suffix: '(UTC/GMT +2)' },
    { countryCode: 'MU', zoneName: 'Indian/Mauritius', suffix: '(UTC/GMT +4)' },
    { countryCode: 'MV', zoneName: 'Indian/Maldives', suffix: '(UTC/GMT +5)' },
    { countryCode: 'MW', zoneName: 'Africa/Blantyre', suffix: '(UTC/GMT +2)' },
    { countryCode: 'MX', zoneName: 'America/Bahia_Banderas', suffix: '(UTC/GMT -5)' },
    { countryCode: 'MX', zoneName: 'America/Cancun', suffix: '(UTC/GMT -5)' },
    { countryCode: 'MX', zoneName: 'America/Chihuahua', suffix: '(UTC/GMT -6)' },
    { countryCode: 'MX', zoneName: 'America/Hermosillo', suffix: '(UTC/GMT -7)' },
    { countryCode: 'MX', zoneName: 'America/Matamoros', suffix: '(UTC/GMT -5)' },
    { countryCode: 'MX', zoneName: 'America/Mazatlan', suffix: '(UTC/GMT -6)' },
    { countryCode: 'MX', zoneName: 'America/Merida', suffix: '(UTC/GMT -5)' },
    { countryCode: 'MX', zoneName: 'America/Mexico_City', suffix: '(UTC/GMT -5)' },
    { countryCode: 'MX', zoneName: 'America/Monterrey', suffix: '(UTC/GMT -5)' },
    { countryCode: 'MX', zoneName: 'America/Ojinaga', suffix: '(UTC/GMT -6)' },
    { countryCode: 'MX', zoneName: 'America/Tijuana', suffix: '(UTC/GMT -7)' },
    { countryCode: 'MY', zoneName: 'Asia/Kuala_Lumpur', suffix: '(UTC/GMT +8)' },
    { countryCode: 'MY', zoneName: 'Asia/Kuching', suffix: '(UTC/GMT +8)' },
    { countryCode: 'MZ', zoneName: 'Africa/Maputo', suffix: '(UTC/GMT +2)' },
    { countryCode: 'NA', zoneName: 'Africa/Windhoek', suffix: '(UTC/GMT +2)' },
    { countryCode: 'NC', zoneName: 'Pacific/Noumea', suffix: '(UTC/GMT +11)' },
    { countryCode: 'NE', zoneName: 'Africa/Niamey', suffix: '(UTC/GMT +1)' },
    { countryCode: 'NF', zoneName: 'Pacific/Norfolk', suffix: '(UTC/GMT +11)' },
    { countryCode: 'NG', zoneName: 'Africa/Lagos', suffix: '(UTC/GMT +1)' },
    { countryCode: 'NI', zoneName: 'America/Managua', suffix: '(UTC/GMT -6)' },
    { countryCode: 'NL', zoneName: 'Europe/Amsterdam', suffix: '(UTC/GMT +2)' },
    { countryCode: 'NO', zoneName: 'Europe/Oslo', suffix: '(UTC/GMT +2)' },
    { countryCode: 'NP', zoneName: 'Asia/Kathmandu', suffix: '(UTC/GMT +5.75)' },
    { countryCode: 'NR', zoneName: 'Pacific/Nauru', suffix: '(UTC/GMT +12)' },
    { countryCode: 'NU', zoneName: 'Pacific/Niue', suffix: '(UTC/GMT -11)' },
    { countryCode: 'NZ', zoneName: 'Pacific/Auckland', suffix: '(UTC/GMT +12)' },
    { countryCode: 'NZ', zoneName: 'Pacific/Chatham', suffix: '(UTC/GMT +12.75)' },
    { countryCode: 'OM', zoneName: 'Asia/Muscat', suffix: '(UTC/GMT +4)' },
    { countryCode: 'PA', zoneName: 'America/Panama', suffix: '(UTC/GMT -5)' },
    { countryCode: 'PE', zoneName: 'America/Lima', suffix: '(UTC/GMT -5)' },
    { countryCode: 'PF', zoneName: 'Pacific/Gambier', suffix: '(UTC/GMT -9)' },
    { countryCode: 'PF', zoneName: 'Pacific/Marquesas', suffix: '(UTC/GMT -9.5)' },
    { countryCode: 'PF', zoneName: 'Pacific/Tahiti', suffix: '(UTC/GMT -10)' },
    { countryCode: 'PG', zoneName: 'Pacific/Bougainville', suffix: '(UTC/GMT +11)' },
    { countryCode: 'PG', zoneName: 'Pacific/Port_Moresby', suffix: '(UTC/GMT +10)' },
    { countryCode: 'PH', zoneName: 'Asia/Manila', suffix: '(UTC/GMT +8)' },
    { countryCode: 'PK', zoneName: 'Asia/Karachi', suffix: '(UTC/GMT +5)' },
    { countryCode: 'PL', zoneName: 'Europe/Warsaw', suffix: '(UTC/GMT +2)' },
    { countryCode: 'PM', zoneName: 'America/Miquelon', suffix: '(UTC/GMT -2)' },
    { countryCode: 'PN', zoneName: 'Pacific/Pitcairn', suffix: '(UTC/GMT -8)' },
    { countryCode: 'PR', zoneName: 'America/Puerto_Rico', suffix: '(UTC/GMT -4)' },
    { countryCode: 'PS', zoneName: 'Asia/Gaza', suffix: '(UTC/GMT +3)' },
    { countryCode: 'PS', zoneName: 'Asia/Hebron', suffix: '(UTC/GMT +3)' },
    { countryCode: 'PT', zoneName: 'Atlantic/Azores', suffix: '(UTC/GMT 0)' },
    { countryCode: 'PT', zoneName: 'Atlantic/Madeira', suffix: '(UTC/GMT +1)' },
    { countryCode: 'PT', zoneName: 'Europe/Lisbon', suffix: '(UTC/GMT +1)' },
    { countryCode: 'PW', zoneName: 'Pacific/Palau', suffix: '(UTC/GMT +9)' },
    { countryCode: 'PY', zoneName: 'America/Asuncion', suffix: '(UTC/GMT -4)' },
    { countryCode: 'QA', zoneName: 'Asia/Qatar', suffix: '(UTC/GMT +3)' },
    { countryCode: 'RE', zoneName: 'Indian/Reunion', suffix: '(UTC/GMT +4)' },
    { countryCode: 'RO', zoneName: 'Europe/Bucharest', suffix: '(UTC/GMT +3)' },
    { countryCode: 'RS', zoneName: 'Europe/Belgrade', suffix: '(UTC/GMT +2)' },
    { countryCode: 'RU', zoneName: 'Asia/Anadyr', suffix: '(UTC/GMT +12)' },
    { countryCode: 'RU', zoneName: 'Asia/Barnaul', suffix: '(UTC/GMT +7)' },
    { countryCode: 'RU', zoneName: 'Asia/Chita', suffix: '(UTC/GMT +9)' },
    { countryCode: 'RU', zoneName: 'Asia/Irkutsk', suffix: '(UTC/GMT +8)' },
    { countryCode: 'RU', zoneName: 'Asia/Kamchatka', suffix: '(UTC/GMT +12)' },
    { countryCode: 'RU', zoneName: 'Asia/Khandyga', suffix: '(UTC/GMT +9)' },
    { countryCode: 'RU', zoneName: 'Asia/Krasnoyarsk', suffix: '(UTC/GMT +7)' },
    { countryCode: 'RU', zoneName: 'Asia/Magadan', suffix: '(UTC/GMT +11)' },
    { countryCode: 'RU', zoneName: 'Asia/Novokuznetsk', suffix: '(UTC/GMT +7)' },
    { countryCode: 'RU', zoneName: 'Asia/Novosibirsk', suffix: '(UTC/GMT +7)' },
    { countryCode: 'RU', zoneName: 'Asia/Omsk', suffix: '(UTC/GMT +6)' },
    { countryCode: 'RU', zoneName: 'Asia/Sakhalin', suffix: '(UTC/GMT +11)' },
    { countryCode: 'RU', zoneName: 'Asia/Srednekolymsk', suffix: '(UTC/GMT +11)' },
    { countryCode: 'RU', zoneName: 'Asia/Tomsk', suffix: '(UTC/GMT +7)' },
    { countryCode: 'RU', zoneName: 'Asia/Ust-Nera', suffix: '(UTC/GMT +10)' },
    { countryCode: 'RU', zoneName: 'Asia/Vladivostok', suffix: '(UTC/GMT +10)' },
    { countryCode: 'RU', zoneName: 'Asia/Yakutsk', suffix: '(UTC/GMT +9)' },
    { countryCode: 'RU', zoneName: 'Asia/Yekaterinburg', suffix: '(UTC/GMT +5)' },
    { countryCode: 'RU', zoneName: 'Europe/Astrakhan', suffix: '(UTC/GMT +4)' },
    { countryCode: 'RU', zoneName: 'Europe/Kaliningrad', suffix: '(UTC/GMT +2)' },
    { countryCode: 'RU', zoneName: 'Europe/Kirov', suffix: '(UTC/GMT +3)' },
    { countryCode: 'RU', zoneName: 'Europe/Moscow', suffix: '(UTC/GMT +3)' },
    { countryCode: 'RU', zoneName: 'Europe/Samara', suffix: '(UTC/GMT +4)' },
    { countryCode: 'RU', zoneName: 'Europe/Simferopol', suffix: '(UTC/GMT +3)' },
    { countryCode: 'RU', zoneName: 'Europe/Ulyanovsk', suffix: '(UTC/GMT +4)' },
    { countryCode: 'RU', zoneName: 'Europe/Volgograd', suffix: '(UTC/GMT +3)' },
    { countryCode: 'RW', zoneName: 'Africa/Kigali', suffix: '(UTC/GMT +2)' },
    { countryCode: 'SA', zoneName: 'Asia/Riyadh', suffix: '(UTC/GMT +3)' },
    { countryCode: 'SB', zoneName: 'Pacific/Guadalcanal', suffix: '(UTC/GMT +11)' },
    { countryCode: 'SC', zoneName: 'Indian/Mahe', suffix: '(UTC/GMT +4)' },
    { countryCode: 'SD', zoneName: 'Africa/Khartoum', suffix: '(UTC/GMT +3)' },
    { countryCode: 'SE', zoneName: 'Europe/Stockholm', suffix: '(UTC/GMT +2)' },
    { countryCode: 'SG', zoneName: 'Asia/Singapore', suffix: '(UTC/GMT +8)' },
    { countryCode: 'SH', zoneName: 'Atlantic/St_Helena', suffix: '(UTC/GMT 0)' },
    { countryCode: 'SI', zoneName: 'Europe/Ljubljana', suffix: '(UTC/GMT +2)' },
    { countryCode: 'SJ', zoneName: 'Arctic/Longyearbyen', suffix: '(UTC/GMT +2)' },
    { countryCode: 'SK', zoneName: 'Europe/Bratislava', suffix: '(UTC/GMT +2)' },
    { countryCode: 'SL', zoneName: 'Africa/Freetown', suffix: '(UTC/GMT 0)' },
    { countryCode: 'SM', zoneName: 'Europe/San_Marino', suffix: '(UTC/GMT +2)' },
    { countryCode: 'SN', zoneName: 'Africa/Dakar', suffix: '(UTC/GMT 0)' },
    { countryCode: 'SO', zoneName: 'Africa/Mogadishu', suffix: '(UTC/GMT +3)' },
    { countryCode: 'SR', zoneName: 'America/Paramaribo', suffix: '(UTC/GMT -3)' },
    { countryCode: 'ST', zoneName: 'Africa/Sao_Tome', suffix: '(UTC/GMT 0)' },
    { countryCode: 'SV', zoneName: 'America/El_Salvador', suffix: '(UTC/GMT -6)' },
    { countryCode: 'SY', zoneName: 'Asia/Damascus', suffix: '(UTC/GMT +3)' },
    { countryCode: 'SZ', zoneName: 'Africa/Mbabane', suffix: '(UTC/GMT +2)' },
    { countryCode: 'TC', zoneName: 'America/Grand_Turk', suffix: '(UTC/GMT -4)' },
    { countryCode: 'TD', zoneName: 'Africa/Ndjamena', suffix: '(UTC/GMT +1)' },
    { countryCode: 'TF', zoneName: 'Indian/Kerguelen', suffix: '(UTC/GMT +5)' },
    { countryCode: 'TG', zoneName: 'Africa/Lome', suffix: '(UTC/GMT 0)' },
    { countryCode: 'TH', zoneName: 'Asia/Bangkok', suffix: '(UTC/GMT +7)' },
    { countryCode: 'TJ', zoneName: 'Asia/Dushanbe', suffix: '(UTC/GMT +5)' },
    { countryCode: 'TK', zoneName: 'Pacific/Fakaofo', suffix: '(UTC/GMT +13)' },
    { countryCode: 'TM', zoneName: 'Asia/Ashgabat', suffix: '(UTC/GMT +5)' },
    { countryCode: 'TN', zoneName: 'Africa/Tunis', suffix: '(UTC/GMT +1)' },
    { countryCode: 'TO', zoneName: 'Pacific/Tongatapu', suffix: '(UTC/GMT +13)' },
    { countryCode: 'TR', zoneName: 'Europe/Istanbul', suffix: '(UTC/GMT +3)' },
    { countryCode: 'TT', zoneName: 'America/Port_of_Spain', suffix: '(UTC/GMT -4)' },
    { countryCode: 'TV', zoneName: 'Pacific/Funafuti', suffix: '(UTC/GMT +12)' },
    { countryCode: 'TW', zoneName: 'Asia/Taipei', suffix: '(UTC/GMT +8)' },
    { countryCode: 'TZ', zoneName: 'Africa/Dar_es_Salaam', suffix: '(UTC/GMT +3)' },
    { countryCode: 'UA', zoneName: 'Europe/Kiev', suffix: '(UTC/GMT +3)' },
    { countryCode: 'UA', zoneName: 'Europe/Uzhgorod', suffix: '(UTC/GMT +3)' },
    { countryCode: 'UA', zoneName: 'Europe/Zaporozhye', suffix: '(UTC/GMT +3)' },
    { countryCode: 'UG', zoneName: 'Africa/Kampala', suffix: '(UTC/GMT +3)' },
    { countryCode: 'UM', zoneName: 'Pacific/Johnston', suffix: '(UTC/GMT -10)' },
    { countryCode: 'UM', zoneName: 'Pacific/Midway', suffix: '(UTC/GMT -11)' },
    { countryCode: 'UM', zoneName: 'Pacific/Wake', suffix: '(UTC/GMT +12)' },
    { countryCode: 'US', zoneName: 'America/Adak', suffix: '(UTC/GMT -9)' },
    { countryCode: 'US', zoneName: 'America/Anchorage', suffix: '(UTC/GMT -8)' },
    { countryCode: 'US', zoneName: 'America/Boise', suffix: '(UTC/GMT -6)' },
    { countryCode: 'US', zoneName: 'America/Chicago', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/Denver', suffix: '(UTC/GMT -6)' },
    { countryCode: 'US', zoneName: 'America/Detroit', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Indianapolis', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Knox', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Marengo', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Petersburg', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Tell_City', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Vevay', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Vincennes', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Indiana/Winamac', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Juneau', suffix: '(UTC/GMT -8)' },
    { countryCode: 'US', zoneName: 'America/Kentucky/Louisville', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Kentucky/Monticello', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Los_Angeles', suffix: '(UTC/GMT -7)' },
    { countryCode: 'US', zoneName: 'America/Menominee', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/Metlakatla', suffix: '(UTC/GMT -8)' },
    { countryCode: 'US', zoneName: 'America/New_York', suffix: '(UTC/GMT -4)' },
    { countryCode: 'US', zoneName: 'America/Nome', suffix: '(UTC/GMT -8)' },
    { countryCode: 'US', zoneName: 'America/North_Dakota/Beulah', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/North_Dakota/Center', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/North_Dakota/New_Salem', suffix: '(UTC/GMT -5)' },
    { countryCode: 'US', zoneName: 'America/Phoenix', suffix: '(UTC/GMT -7)' },
    { countryCode: 'US', zoneName: 'America/Sitka', suffix: '(UTC/GMT -8)' },
    { countryCode: 'US', zoneName: 'America/Yakutat', suffix: '(UTC/GMT -8)' },
    { countryCode: 'US', zoneName: 'Pacific/Honolulu', suffix: '(UTC/GMT -10)' },
    { countryCode: 'UY', zoneName: 'America/Montevideo', suffix: '(UTC/GMT -3)' },
    { countryCode: 'UZ', zoneName: 'Asia/Samarkand', suffix: '(UTC/GMT +5)' },
    { countryCode: 'UZ', zoneName: 'Asia/Tashkent', suffix: '(UTC/GMT +5)' },
    { countryCode: 'VA', zoneName: 'Europe/Vatican', suffix: '(UTC/GMT +2)' },
    { countryCode: 'VC', zoneName: 'America/St_Vincent', suffix: '(UTC/GMT -4)' },
    { countryCode: 'VE', zoneName: 'America/Caracas', suffix: '(UTC/GMT -4)' },
    { countryCode: 'VG', zoneName: 'America/Tortola', suffix: '(UTC/GMT -4)' },
    { countryCode: 'VI', zoneName: 'America/St_Thomas', suffix: '(UTC/GMT -4)' },
    { countryCode: 'VN', zoneName: 'Asia/Ho_Chi_Minh', suffix: '(UTC/GMT +7)' },
    { countryCode: 'VU', zoneName: 'Pacific/Efate', suffix: '(UTC/GMT +11)' },
    { countryCode: 'WF', zoneName: 'Pacific/Wallis', suffix: '(UTC/GMT +12)' },
    { countryCode: 'WS', zoneName: 'Pacific/Apia', suffix: '(UTC/GMT +13)' },
    { countryCode: 'YE', zoneName: 'Asia/Aden', suffix: '(UTC/GMT +3)' },
    { countryCode: 'YT', zoneName: 'Indian/Mayotte', suffix: '(UTC/GMT +3)' },
    { countryCode: 'ZA', zoneName: 'Africa/Johannesburg', suffix: '(UTC/GMT +2)' },
    { countryCode: 'ZM', zoneName: 'Africa/Lusaka', suffix: '(UTC/GMT +2)' },
    { countryCode: 'ZW', zoneName: 'Africa/Harare', suffix: '(UTC/GMT +2)' }
  ]
};

export const DEFAULT_IMAGE =
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw0NDQ0NDQ0PDg0NDQ0NDQ0NDQ8NDQ4NFhEWFhURExMYHSggGBolGxUWITEhJSkrLi4uFx8zODMsNygtLisBCgoKBQUFDgUFDisZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAJ8BPgMBIgACEQEDEQH/xAAaAAEBAQEBAQEAAAAAAAAAAAAAAgEDBAUH/8QAMBABAQACAAIGCAcBAQAAAAAAAAECEQMEEiExQVJxFTJRYWKRobEFExQigZKi0XL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A/RAAAAAAAAAADQ0GaNNAZo0oBOjSzQI0adDQOejTpo0Dno0vRoEaNLYCdGlMBg2sAAAAAAAAAAAAAAAAAAAAAayKBjRoDdEipATpulaboE6NLkNAjRpejQIZpemaBGmLsZYCBVTQZWNYAAAAAAAAAAAAAAAAAAAABFJioDWyEVAFSEipAZMVSNkVICZG6Xo0COizTthw7l1SW+UdOLyuWGPSuu3Wu2wHk0yx1sTYDlYyulibAc9JrpU0EJVUgAAAAAAAAAAAAAAAAAAAARcRF4gqKjIuA2RWMZHfg8HLL1cbff3fMESKmL28LkPHf4x/69Mxw4fZjd+7G2/MHi4XKZ5d2p7+p6ceUwx68rvz6ozPj8S+rhZ77La4ZY53rsyvnKD0Zc1hj1YzflNRWN/N4dl7bueV7nk/Ly8N+Vd+U3LZZdWey9oPBcU2PbzXBvStktl6+qb63C8HPwZf1oPNYmx1sRYDlU10sRkDlUrqAAAAAAAAAAAAAAAAAAAAAI6YucdMQXF4oi8Qev8AD5jc9ZSXc6t+17+Z5n8vUmPbOr2Pk8PKyyztllj6nN49PhzOd2sv47wOT4uWeWXSvdNTuis+a6Ns6O9X2uX4d25eUc+P6+XmD0fq/h+p+q+H6rnLY613+3byZTVs9lsB6f1Xw/Vl5v4fq8yuJhcdb75sHa858P1duX43T31a179vn16uQ7MvOfYHg4vrZed+7lXbi+tfO/dxoIrnXSudBzyRV5IoAAAAAAAAAAAAAAAAAAAAEdMXOOmILi8XOLgLj6n4fn0sLhe77V8qPVyXF6OePsv7b/IPXyWHRzzxvc48f18vN75w9Z3L24yXzj5/Mevl5g7Y8zlJrq8+9y2rluF07u+rO2+33PTxOWl7P2/YHPluFu7vZOz316eJw5lOvuVjjJJJ2RoPnc1h0curss3HbkOzLzn2bz+O8Zl7L9Kn8OvVl5wHh4vrXzv3csl8W/uy8793Ogioq7UZA55IXkgAAAAAAAAAAAAAAAAAAAACLiIqAuKiIqA6Sqlc5VSg+7yvE6eGN79avnHh5jDLp5axys32yVz5Tm/y5ZZuXr7dar0+kp4L/YDHmOJJqcPUnw5N/VcXwf5yPSM8H1PSM8F+YN/VcTwf5yZ+q4vg/wA5HpGeC/M9IzwfUE8Tj8TKWXDqvV6uTr+HY2TLcs652zTn6SngvzZ6Tngv9geHi392X/q/dztbnlu2+22otBlTk2poIqVVIAAAAAAAAAAAAAAAAAAAAEVEqBqpUNBcqtucqtguVUrnK3YOkrduezYOmzbn0i0FbZck7ZsG2stZtloFqaUBiWsAAAAAAAAAAAAAAAAAAAAAaxoDWAKakBcptICzaGgrZtIDdm07Ng3bGAAMArG1gAAAAAAAAAAAAAAAAAAAABsAaMAaMAUJAUJAUJAUJAaMAaMAbWAAAAAAAAAAAD//2Q==';
